import React from 'react'
import { I18n } from 'react-redux-i18n'
import ScheduleModal from 'components/ScheduleModal'
import _clonedeep from 'lodash.clonedeep'
import { ButtonTag } from 'components/Form'

const schedule = [{
  isActive: true,
  name: 'channels',
  timeZone: 'Europe/Madrid',
  monday: {
    isActive: true,
    ranges: [{ start: "00:00", end: "23:59" }],
  },
  tuesday: {
    isActive: true,
    ranges: [{ start: "00:00", end: "23:59" }],
  },
  wednesday: {
    isActive: true,
    ranges: [{ start: "00:00", end: "23:59" }],
  },
  thursday: {
    isActive: true,
    ranges: [{ start: "00:00", end: "23:59" }],
  },
  friday: {
    isActive: true,
    ranges: [{ start: "00:00", end: "23:59" }],
  },
  saturday: {
    isActive: true,
    ranges: [{ start: "00:00", end: "23:59" }],
  },
  sunday: {
    isActive: true,
    ranges: [{ start: "00:00", end: "23:59" }],
  },
}]


/**
 * ScheduleButton
 * @param {object} props
 */
const ScheduleButton = (props) => {
  const { id, value = {}, onChange, className, label, description } = props
  const [modalSchedule, setModalSchedule] = React.useState(false)
  const toggleModalSchedule = () => { setModalSchedule(!modalSchedule) }

  const saveSchedule = (_schedule) => {
    return new Promise((resolve, reject) => {
      const displaySchedule = {
        ..._schedule,
        name: _schedule.name || schedule[0].name,
        timeZone: _schedule.timeZone || schedule[0].timeZone,
        isActive: _schedule.isActive || schedule[0].isActive
      }
      onChange(displaySchedule)
      return resolve()
    })
  }

  return (
    <div className={`channel-field input ${className ? className : ''}`}>
      {label && <label htmlFor={id}>{I18n.t(label)}</label>}
      <div className={`field-content ${!className ? 'grid grid--small' : ''}`}>
        <ButtonTag
          value={I18n.t('dashboard_schedule-text')}
          onClick={toggleModalSchedule}
          size={'large'}
        />
        {modalSchedule && <div className='modal-background'>
          <ScheduleModal
            scheduleMode={'chatweb'}
            closeModal={toggleModalSchedule}
            saveSchedules={saveSchedule}
            schedules={Object.keys(value).length ? [value] : _clonedeep(schedule)}/>
        </div>}
        {description && <p className='description'>{I18n.t(description)}</p>}
      </div>
    </div>
  )
}

export default ScheduleButton
